import {
  HashRouter,
  Routes,
  Route
} from 'react-router-dom';

import RootPage from './components/rootPage';

import Login, { route as LOGIN_ROUTE } from './features/login';
import Logout, {route as LOGOUT_ROUTE} from "./features/logout";
import ManageUsers, { route as MANAGE_USERS_ROUTE } from './features/manageUsers';
import AcceptTerms, {route as ACCEPT_TERMS_ROUTE} from './features/acceptTerms';

import Auth from './components/common/authenticatedRoute';
import UnAuth from './components/common/unauthenticatedRoute';
import Tabledemo, {route as TABLEDEMO_ROUTE} from "./features/tabledemo";
import SwitchDistricts, {route as SWITCH_DISTRICTS_ROUTE} from "./features/switchDistricts";
import ForgotPassword, {route as FORGOT_PASSWORD_ROUTE} from "./features/forgotPassword";
import MyReports, { route as MY_REPORTS_ROUTE } from './features/myReports';
import SampleReports, { route as SAMPLE_REPORTS_ROUTE} from "./features/sampleReports";
import StatusReport, {route as STATUS_REPORT_ROUTE} from "./features/statusReport";
import ErrorReport, {route as ERROR_REPORT_ROUTE} from "./features/errorReport";
import MyData, {route as MY_DATA_ROUTE} from "./features/myData";
import UploadData, {route as UPLOAD_DATA_ROUTE} from "./features/uploadData";
import AddDistrict, {route as ADD_DISTRICT_ROUTE} from "./features/addDistrict";
import MyProfile, {route as MY_PROFILE_ROUTE} from "./features/myProfile";
import ChangePassword, {route as CHANGE_PASSWORD_ROUTE} from "./features/changePassword";
import SchoolProfile, {route as SCHOOL_PROFILE_ROUTE} from "./features/schoolProfile";
import ManageSchools, {route as MANAGE_SCHOOLS_ROUTE} from "./features/manageSchools";
import EditDistrict, {route as EDIT_DISTRICT_ROUTE} from "./features/editDistrict";
import ResetPassword, {route as RESET_PASSWORD_ROUTE} from "./features/resetPassword";
import ManageUserProfile, {route as MANAGE_USER_PROFILE_ROUTE} from "./features/manageUserProfile";
import CreateUser, {route as CREATE_USER_ROUTE} from "./features/createUser";
import AddSchool, {route as ADD_SCHOOL_ROUTE} from "./features/addSchool";

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { restoreSessionFromLocalStorage } from './actions/session';

import Dashboard, { route as DASHBOARD_ROUTE } from './features/dashboard';
import {restoreCurrentDistrictFromLocalStorage} from "./actions/districts";
import {restorePermissionsListFromLocalStorage} from "./actions/users";


const App = (props) => {
  const dispatch = useDispatch();

  const attemptedToRestoreSession = useSelector((state) => state.session.attemptedToRestoreSession);

  useEffect(() => {
    dispatch(restoreSessionFromLocalStorage());
    dispatch(restoreCurrentDistrictFromLocalStorage());
    dispatch(restorePermissionsListFromLocalStorage());
  }, [dispatch]);

  // we don't want to render the router until after we've attempted to restore a
  // previous session otherwise the unauthed route will always trigger when the page
  // loads and overwrite the url even if the user is loggged in
  return attemptedToRestoreSession ?
    (
      <HashRouter>
        <Routes>
          <Route path='/' element={ <RootPage /> } >
            <Route index element={ <UnAuth><Login /></UnAuth> } />

            <Route path={TABLEDEMO_ROUTE} element={<UnAuth><Tabledemo /></UnAuth>} />

            <Route path={LOGIN_ROUTE} element={<UnAuth><Login /></UnAuth>} />
            <Route path={ACCEPT_TERMS_ROUTE} element={<Auth><AcceptTerms/></Auth>}/>
            <Route path={LOGOUT_ROUTE} element={<Auth><Logout /></Auth>} />

            <Route path={DASHBOARD_ROUTE} element={<Auth><Dashboard/></Auth>} />
            <Route path={FORGOT_PASSWORD_ROUTE} element={<UnAuth><ForgotPassword /></UnAuth>} />
            <Route path={RESET_PASSWORD_ROUTE} element={<UnAuth><ResetPassword /></UnAuth>} />

            <Route path={MANAGE_USERS_ROUTE} element={<Auth permission={MANAGE_USERS_ROUTE}><ManageUsers/></Auth>} />
            <Route path={MY_REPORTS_ROUTE} element={<Auth permission={MY_REPORTS_ROUTE}><MyReports/></Auth>} />
            <Route path={SAMPLE_REPORTS_ROUTE} element={<Auth permission={SAMPLE_REPORTS_ROUTE}><SampleReports/></Auth>} />
            <Route path={STATUS_REPORT_ROUTE} element={<Auth permission={STATUS_REPORT_ROUTE}><StatusReport/></Auth>} />
            <Route path={ERROR_REPORT_ROUTE} element={<Auth permission={ERROR_REPORT_ROUTE}><ErrorReport/></Auth>} />
            <Route path={SWITCH_DISTRICTS_ROUTE} element={<Auth permission={SWITCH_DISTRICTS_ROUTE}><SwitchDistricts/></Auth>} />
            <Route path={ADD_DISTRICT_ROUTE} element={<Auth permission={ADD_DISTRICT_ROUTE}><AddDistrict/></Auth>}/>
            <Route path={MANAGE_SCHOOLS_ROUTE} element={<Auth permission={MANAGE_SCHOOLS_ROUTE}><ManageSchools/></Auth>}/>
            <Route path={SCHOOL_PROFILE_ROUTE} element={<Auth permission={SCHOOL_PROFILE_ROUTE}><SchoolProfile/></Auth>}/>
            <Route path={EDIT_DISTRICT_ROUTE} element={<Auth permission={MANAGE_SCHOOLS_ROUTE}><EditDistrict/></Auth>}/>
            <Route path={ADD_SCHOOL_ROUTE} element={<Auth permission={MANAGE_SCHOOLS_ROUTE}><AddSchool/></Auth>}/>
            <Route path={MY_PROFILE_ROUTE} element={<Auth><MyProfile/></Auth>}/>
            <Route path={CHANGE_PASSWORD_ROUTE} element={<Auth><ChangePassword/></Auth>}/>
            <Route path={MY_DATA_ROUTE} element={<Auth permission={MY_DATA_ROUTE}><MyData/></Auth>}/>
            <Route path={UPLOAD_DATA_ROUTE} element={<Auth permission={UPLOAD_DATA_ROUTE}><UploadData/></Auth>} />
            <Route path={MANAGE_USER_PROFILE_ROUTE} element={<Auth permission={MANAGE_USER_PROFILE_ROUTE}><ManageUserProfile/></Auth>} />
            <Route path={CREATE_USER_ROUTE} element={<Auth permission={CREATE_USER_ROUTE}><CreateUser/></Auth>}/>
          </Route>
        </Routes>
      </HashRouter>
  ) : null;
};

export default App;
